import React from "react";
import classNames from "classnames";

// types
import type { DisclaimerType } from "../../types/api/moneyTransfer";

interface SendMoneyFooterProps {
  /** server HTML (links, line breaks) rendered above the disclaimers */
  content?: string;
  disclaimers?: DisclaimerType[];
  /** "small" — the Transfer Details quote disclaimers (font-size-sm) */
  variant?: "default" | "small";
  className?: string;
}

/**
 * Footer for Send Money screens: optional server HTML content, then each
 * disclaimer with its superscript. Renders nothing when there's neither.
 */
const SendMoneyFooter = ({
  content,
  disclaimers,
  variant = "default",
  className,
}: SendMoneyFooterProps): React.ReactElement | null => {
  const hasContent = Boolean(content);
  const hasDisclaimers = Boolean(disclaimers?.length);

  if (!hasContent && !hasDisclaimers) return null;

  const textClassName = classNames("text-secondary leading-snug", {
    "font-size-sm disclaimer": variant === "small",
  });

  return (
    <div className={className}>
      {hasContent && (
        <p className={textClassName} dangerouslySetInnerHTML={{ __html: content as string }} />
      )}

      {disclaimers?.map((disclaimer) => (
        <p className={textClassName} key={disclaimer.disclaimerId}>
          <sup>{disclaimer.superscript}</sup> {disclaimer.text}
        </p>
      ))}
    </div>
  );
};

export default SendMoneyFooter;